var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$vuetify.breakpoint.mobile)?_c('PrenotazioniDesktop'):_c('PrenotazioniMobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }